'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024158 from "./presto.types$$anon$158.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dSeed$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Seed-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthPayload$$anon$157() {
  this.cca = null;
  this.cc2 = null;
  this.cc3 = false;
  this.ccb = null;
  this.ccc = false;
  this.ccf = null;
  this.cc8 = null;
  this.cc9 = false;
  this.cc4 = null;
  this.cc5 = false;
  this.cc6 = null;
  this.cc7 = false;
  this.ccd = false;
  this.cce = false;
  this.cca = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ccf = "TwoFactorAuthSeedPayload";
}
export { $c_Lpresto_types$TwoFactorAuthPayload$$anon$157 as $c_Lpresto_types$TwoFactorAuthPayload$$anon$157 };
$p = $c_Lpresto_types$TwoFactorAuthPayload$$anon$157.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthPayload$$anon$157;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthPayload$$anon$157() {
}
export { $h_Lpresto_types$TwoFactorAuthPayload$$anon$157 as $h_Lpresto_types$TwoFactorAuthPayload$$anon$157 };
$h_Lpresto_types$TwoFactorAuthPayload$$anon$157.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.cca;
});
$p.M = (function() {
  if ((!this.cc3)) {
    this.cc2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.cc3 = true;
  }
  return this.cc2;
});
$p.O = (function() {
  if ((!this.ccc)) {
    this.ccb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ccc = true;
  }
  return this.ccb;
});
$p.E = (function() {
  return this.ccf;
});
$p.t = (function() {
  if ((!this.cc9)) {
    this.cc8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("secret", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cc9 = true;
  }
  return this.cc8;
});
$p.N = (function() {
  if ((!this.cc5)) {
    this.cc4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cc5 = true;
  }
  return this.cc4;
});
$p.Q = (function() {
  if ((!this.cc7)) {
    this.cc6 = new $j_presto$002etypes$0024$0024anon$0024158.$c_Lpresto_types$$anon$158();
    this.cc7 = true;
  }
  return this.cc6;
});
$p.v = (function() {
  if ((!this.cce)) {
    this.ccd = false;
    this.cce = true;
  }
  return this.ccd;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee175) => ((p) => \u03b4scrutinee175.cG5(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dSeed$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthSeedPayload$())));
});
var $d_Lpresto_types$TwoFactorAuthPayload$$anon$157 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthPayload$$anon$157, "presto.types$TwoFactorAuthPayload$$anon$157", ({
  a2K: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$TwoFactorAuthPayload$$anon$157 as $d_Lpresto_types$TwoFactorAuthPayload$$anon$157 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Payload$$anon$157.js.map
